import { render, staticRenderFns } from "./ReservationCautionTemplate.vue?vue&type=template&id=8bede56c&scoped=true&"
import script from "./ReservationCautionTemplate.vue?vue&type=script&lang=ts&"
export * from "./ReservationCautionTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationCautionTemplate.vue?vue&type=style&index=0&id=8bede56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bede56c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VContainer})
